import ywk, { utils } from '@clouderwork/ywk'
import OSS from 'ali-oss'
import hash from 'blueimp-md5';

let OSS_TOKEN_CACHE: any = {}

/**
 * 获取 OSS 配置
 */
export const getOssToken = () => {
  return new Promise((resolve, reject) => {
    if (OSS_TOKEN_CACHE && OSS_TOKEN_CACHE.Expiration) {
      const expire = new Date(OSS_TOKEN_CACHE.Expiration)

      if (expire > new Date()) {
        return resolve(OSS_TOKEN_CACHE)
      }
    }

    ywk.ajax.getJson('/company/api/files/source').then(res => {
      if (res.error_code === 0) {
        resolve(OSS_TOKEN_CACHE = res.result)
      } else {
        console.log('[BASE]: Get OSS_TOKEN Error!', res)
      }
    })
  })
}

/**
 * OSS 上传文件
 */
export const setOssUpload = (filename, file, options?: any) => {
  return getOssToken().then((config: any) => {
    const { AccessKeyId, AccessKeySecret, SecurityToken, bucket, endpoint, callback_url } = config
    // TODO filename加md5后缀
    const client = new OSS({
      accessKeyId: AccessKeyId,
      accessKeySecret: AccessKeySecret,
      stsToken: SecurityToken,
      bucket,
      endpoint
    });
    let nameSplit = filename.split('.');
    const hashName = hash(filename);
    const projectName = options.projectName || '';
    const moduleName = options.moduleName || '';
    const type = nameSplit[nameSplit.length - 1];
    const postName = `${projectName}${moduleName}${hashName}.${type}`;
    console.log(postName);
    return client.multipartUpload(postName, file, {
      callback: {
        url: callback_url,
        body: '{"bucket": ${bucket},\
            "path": ${object},\
            "etag": ${etag},\
            "size": ${size},\
            "mimeType": ${mimeType},\
            "imageInfo.height": "${imageInfo.height}",\
            "imageInfo.width": "${imageInfo.width}",\
            "imageInfo.format": ${imageInfo.format},\
            "my_var": ${x:my_var},\
            "name": "'+ filename + '"\
        }',
        contentType: 'application/json'

      },
      progress: options && options.progress
      // progress: (p, checkpoint) => {
      //   console.log('上传进度', p)
      // }
    }).catch((err) => {
      console.error(err);
    })
  })
}

/**
 * B64 转文件
 */
export const dataURLtoFile = function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

/**
 * OSS 上传 B64 文件
 */
export const setOssUpload64 = (filename, dataurl, options) => setOssUpload(
  filename,
  dataURLtoFile(dataurl, filename),
  options
)